<template>
  <div v-if="svgs">
    <template v-for="(svg, i) in svgs">
      <span :key="i" class="figure-block">
        <span v-html="svg" />
        <b>{{ boxes[i].name }}</b><br>
        packed: {{ boxes[i].items.length }}<br>
        weight: {{ boxes[i].weightUsed.toFixed(2) }}
      </span>
    </template>
  </div>
</template>
<script>
export default {
  name: 'RecipeSvgs',
  props: [
    'boxes',
    'svgs'
  ]
}
</script>
